import { Link } from "react-router-dom";
import Button from "../utils/Button";
import { Form, Formik, FormikHelpers } from "formik";
import * as Yup from "yup";
import TextField from "../forms/TextField";
import { variantCreationDTO } from "./variant.model";

export default function VariantForm(props: variantFormProps) {
  return (
    <Formik
      initialValues={props.model}
      onSubmit={props.onSubmit}
      validationSchema={Yup.object({
        name: Yup.string()
          .required("This field is required")
          .firstLetterUppercase(),
      })}
    >
      {(formikProps) => (
        <Form
          placeholder={undefined}
          onPointerEnterCapture={undefined}
          onPointerLeaveCapture={undefined}
        >
          <TextField field="name" displayName="Name" />

          <Button disabled={formikProps.isSubmitting} type="submit">
            Save Changes
          </Button>

          <Link className="btn btn-primary" to="/variants">
            Cancel
          </Link>
        </Form>
      )}
    </Formik>
  );
}

interface variantFormProps {
  model: variantCreationDTO;
  onSubmit(
    values: variantCreationDTO,
    action: FormikHelpers<variantCreationDTO>
  ): void;
}
